import { render, staticRenderFns } from "./vouchers.vue?vue&type=template&id=44c1cb9f"
import script from "./vouchers.vue?vue&type=script&lang=js"
export * from "./vouchers.vue?vue&type=script&lang=js"
import style0 from "./vouchers.vue?vue&type=style&index=0&id=44c1cb9f&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports